import Copyright from './copyright'

export default {
    exchangeToken: '/account/exchangeToken',
    copyrightComponent: Copyright
}
